<h1 translate
    matDialogTitle>
    mail_modal_title
</h1>
<form [formGroup]="form"
      (submit)="onSubmit()">

    <mat-dialog-content>
        <mat-form-field>
            <input [placeholder]="'mail_modal_form_send_to' | translate"
                   [uiAutofocus]
                   matInput
                   formControlName="sendTo"
                   name="sendTo"
                   required
                   data-cy="send-to" />
            <mat-error *ngIf="form.get('sendTo')!.hasError('email')"
                       translate
                       class="errorMessage">
                settings_mail_form_email_invalid_warning
            </mat-error>
            <mat-error *ngIf="form.get('sendTo')!.hasError('maxlength')"
                       [translateParams]="{
                        max: form.get('sendTo').getError('maxlength').requiredLength
                    }"
                       translate
                       class="errorMessage">
                mail_modal_send_to_max_warning
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button"
                data-cy="send-email-cancel">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                        form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary"
                data-cy="send-mail-submit">
            {{ 'modal_action_send' | translate }}
        </button>
    </mat-dialog-actions>

</form>
